import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { point } from '@/utils/pointUtils';
import { isAndroid, gameInfo} from './gameInfoHook';
import { getParam, openNewPageWithCidAndScid } from '@/utils';
import mediaClass  from './queryMediaClass';
import popupHook from './popupHook';
import websiteConfig from '@/configs/websiteConfig';
import { getIpLocation } from '@/api/news'

const safeDistance = websiteConfig.menu.safeDistance; // 导航栏滚动安全区域
// 梁子尧：蚂蚁官网储值展示
const isStore = ref(true);
// hex解码
const hexToString = (str: string) => {
  try {
    str = window.atob(str);
  } catch (_e) {
    return '';
  }

  if (str.length % 2) return '';

  try {
    let strArr = [];
    // 因为大小字母均只有两位
    for (let i = 0; i < str.length; i += 2) {
      strArr.push(parseInt(str.slice(i, i + 2), 16));
    }
    return String.fromCharCode(...strArr);
  } catch (_e) {
    return '';
  }
};
let localCode = '';
const handleIpLocation = async () => {
  if (localCode) {
    if (localCode === 'JP') {
      isStore.value = false;
    }
    return;
  }
  await getIpLocation().then(res => {
    if (+res?.result === 1) {
      try {
        localCode = hexToString(res?.data?.code);
        // 当地区为JP时，强制设置isStore为false
        if (localCode === 'JP') {
          isStore.value = false;
        }
        console.log(localCode)
      } catch (_e) {}
    }
  })
}
// (async () => {
//   if(isStore.value){
//     await handleIpLocation();
//   }
// })();
const menuListMap = computed(() => { // 顶部导航栏配置
  return websiteConfig.menu.list.filter(item => {
    return isStore.value || !item.review; // 链接上不带参数store=1时，则判断是否审核模式，审核模式则不显示
  });
});
const downloadSlideActive = ref(false); // 下载链接下拉状态
let isMovingPage = false; // 页面是否滚动中
export default function () {
  const { hidePopup } = popupHook();
  const route = useRoute();
  const router = useRouter();
  // 获取元素所在的页面位置
  const getElePosition = (ele: Element) => {
    if (!ele || !ele.getBoundingClientRect) {
      return {
        eleTop: 0,
        eleBottom: 0,
      };
    }
    const { top, height } = ele.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      eleTop: top + scrollTop,
      eleBottom: top + scrollTop + height,
    };
  };
  // 移动页面
  const movePage = (distance: number) => {
    isMovingPage = true;
    movePageBySmooth(distance)
      .catch(() => {
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop = distance;
        } else {
          document.body.scrollTop = distance;
        }
      })
      .finally(() => {
        setTimeout(() => {
          isMovingPage = false;
        }, 1200);
      });
  };

  // 平缓移动页面
  const movePageBySmooth = (distance: number) => {
    return new Promise((resolve, reject) => {
      try {
        window.scrollTo({
          top: distance,
          behavior: 'smooth',
        });
        resolve(true);
      } catch (e) {
        reject();
      }
    });
  };
  // 立即下载按钮
  const mobileHeadDownloadClick = () => {
    if (mediaClass.screenType !== 'large' && mediaClass.screenType !== 'tinyLand') {
      window.open(isAndroid ? gameInfo.googlePlay : gameInfo.appstore, '_blank');
      point({
        eventName: 'click_button',
        eventReason: '导航栏',
        eventType: '下载按钮',
      });
    }
  }
  // 处理导航点击事件
  const navEventHandler = (type, target) => {
    // link: 链接跳转
    // routeName： 路由切换
    // scroll： 页面滚动
    const navEventMap = {
      link: () => {
        openNewPageWithCidAndScid({
          link: target,
          type: 'navbar'
        })
      },
      routeName: () => {
        router.push({
          name: target,
        })
      },
      scroll: () => {
        route.name !== 'home'
        &&
        router.push({
          name: 'Home',
        });
        setTimeout(() => {
          const targetSectionTop = getElePosition(document.querySelector(target)).eleTop;
          movePage(targetSectionTop - safeDistance);
        },20)
      }
    }
    navEventMap[type]();
  }
  // 切换导航栏
  const changeNav = ({ target }) => {
    const index = +target.dataset.index;
    if (index < 1) {
      return;
    }
    const nowNavItem = menuListMap.value[index - 1];
    const eventType = ['scroll','routeName','link']
    const type = nowNavItem.type;
    if (!eventType.includes(type)) {
      return;
    }
    point({
      eventName: 'click_button',
      eventReason: '导航栏',
      eventType: nowNavItem.name,
    });
    navEventHandler(type, nowNavItem.target)
    hidePopup();
  };
  return {
    handleIpLocation,
    isStore,
    changeNav,
    downloadSlideActive,
    menuListMap,
    mobileHeadDownloadClick,
    downloadLink: gameInfo,
    websiteConfig
  };
}
